<template>
    <div id="featured-blocks" v-if="data && data.length > 0">
        <div class="col-lg-12 col-md-12 pad-l mt-xs-1 mt-sm-1 mt-md-0 mt-lg-0 pr-3">
            <div class="row">
                <div class="col-md-12 pt-0 pb-2 ofh">
                    <div class="post-overaly-style contentTop hot-post-top clearfix">
                        <div class="post-thumb">
                            <a :href="data[0].post_url">
                                <img class="img-fluid" :src="resizedThumbnail(data[0].photo, 290)" :alt="data[0].title">
                            </a>
                        </div>
                        <div class="post-content">
                            <a class="post-cat" :href="data[0].keywords_search_url">{{ data[0].first_keyword }}</a>
                            <h2 class="post-title title-large">
                                <a :href="data[0].post_url">{{ data[0].title }}</a>
                            </h2>
                            <span class="post-date">{{ data[0].creation_date | formatShortDate }}</span>
                        </div><!-- Post content end -->
                    </div><!-- Post Overaly end -->
                </div><!-- Col end -->

                <div class="col-md-6 pl-3 ofh">
                    <div class="post-overaly-style contentTop hot-post-bottom clearfix d-block-w">
                        <div class="post-thumb">
                            <a :href="data[1].post_url"><img class="img-fluid" :src="data[1].thumbnail" :alt="data[1].title"></a>
                        </div>
                        <div class="post-content">
                            <a class="post-cat" :href="data[1].keywords_search_url">{{ data[1].first_keyword }}</a>
                            <h2 class="post-title title-medium">
                                <a :href="data[1].post_url">{{ data[1].title }}</a>
                            </h2>
                        </div><!-- Post content end -->
                    </div><!-- Post Overaly end -->
                </div><!-- Col end -->

                <div class="col-md-6 pl-3 ofh pt-xs-1 pt-sm-1 pt-md-0 ml-lg-m8">
                    <div class="post-overaly-style contentTop hot-post-bottom clearfix d-block-w">
                        <div class="post-thumb">
                            <a :href="data[2].post_url"><img class="img-fluid" :src="data[2].thumbnail" :alt="data[2].title"></a>
                        </div>
                        <div class="post-content">
                            <a class="post-cat" :href="data[2].keywords_search_url">{{ data[2].first_keyword }}</a>
                            <h2 class="post-title title-medium">
                                <a :href="data[2].post_url">{{ data[2].title }}</a>
                            </h2>
                        </div><!-- Post content end -->
                    </div><!-- Post Overaly end -->
                </div><!-- Col end -->
            </div>
        </div>
    </div>
</template>

<script>
    import { resizedThumbnail } from "../../helpers/helpers";

    export default {
        name: 'FeaturedBlocks',
        props: ['data'],
        methods: {
            resizedThumbnail(url, height) {
                return resizedThumbnail(url, height);
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';
    @import '~@/absctracts/mixins.scss';

    .ofh {
        overflow: hidden;
    }

    .hot-post-top {
        max-height: 282px;
        margin-bottom: 3px;
        height: 282px;

        .post-thumb {
            img {
                height: 290px;
                object-fit: cover;
            }
        }
    }

    .post-thumb {
        max-width: 100%;
        position: relative;
        overflow: hidden;

        img {
            display: block;
            width: 100%;
            object-fit: cover;
            -webkit-transition: all .3s ease-out;
            -o-transition: all .3s ease-out;
            transition: all .3s ease-out;
        }
    }

    #featured-blocks {
        overflow: hidden;

        .post-overaly-style {
            -webkit-transition: all .3s ease-out;
            -o-transition: all .3s ease-out;
            transition: all .3s ease-out;
        }

        .post-overaly-style:hover + .post-thumb a img{

        }

    }

    .post-overaly-style.contentTop .post-content {
        top: 0;
        bottom: auto;
    }

    .hot-post-top .post-content, .hot-post-bottom .post-content {
        padding: 20px;
    }

    .post-overaly-style .post-content {
        position: absolute;
        bottom: 0;
        padding: 25px;
    }

    .post-content {
        padding: 30px;
        z-index: 1;
        position: relative;
    }

    .post-overaly-style {
        position: relative;
        overflow: hidden;
    }

    .post-overaly-style.contentTop:before {
        top: 0;
        left: 0;
        background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.85) 100%);
        background: -webkit-gradient(linear, left top, left bottom, color-stop(60%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, 0.85)));
        background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.85) 100%);
        background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.85) 100%);
        background: -ms-linear-gradient(top, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.85) 100%);
        background: linear-gradient(to top, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.85) 100%);
    }

    .post-overaly-style:before {
        content: " ";
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
        z-index: 1;
        bottom: 0;
        left: 0;
        background: -moz-linear-gradient(bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
        background: -webkit-gradient(linear, left bottom, left bottom, color-stop(60%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, 0.85)));
        background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
        background: -o-linear-gradient(bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
        background: -ms-linear-gradient(bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
    }

    a.post-cat {
        position: relative;
        font-size: 10px;
        padding: 0 5px;
        background: $dark-grey;
        text-transform: uppercase;
        font-weight: 700;
        color: #fff;
        height: 20px;
        line-height: 20px;
        display: inline-block;
    }

    .post-cat:before {
        content: '';
        position: absolute;
        left: 0;
        z-index: 0;
        bottom: -8px;
        border-top: 8px solid $dark-grey;
        border-right: 8px solid transparent;
    }

    .post-title.title-large {
        font-size: 20px;
        line-height: 26px;
        margin-top: 15px;
        margin-bottom: 5px;
    }

    .post-title {
        font-size: 18px;
        line-height: 24px;
        margin: 15px 0 0;
    }

    .post-overaly-style .post-date {
        color: $white;
    }

    @media (min-width: 992px) {
        .pad-r-small {
            padding-right: 1.5px;
        }

        .d-block-w {
            width: 223px;
        }

        .ml-lg-m8 {
            margin-left: -8px;
        }
    }

    .hot-post-bottom, .hot-post-bottom img {
        min-height: 172px;
    }

    .post-overaly-style .post-title a {
        color: $white;
    }

    .post-title.title-medium {
        font-size: 16px;
        line-height: 24px;
        margin-top: 15px;
        margin-bottom: 5px;
    }
</style>